import React, { useEffect, useState } from "react";

import "./index.scss";

export default function DupontCheckbox(props) {
  const {
    id,
    labelText,
    name,
    checked,
    onChange,
    required,
    disabled,
    customClass,
    indeterminate,
    onClick,
    allowAction = true,
  } = props;
  const [isChecked, setIsChecked] = useState(checked);
  const indeterminateStyle = indeterminate
    ? "dupont-checkbox__indeterminate"
    : "";

  useEffect(() => setIsChecked(checked), [checked]);
  const checkboxId = id;

  const clickHandler = () => {
    // Prevent checking only if not allowed & unchecked
    if (!isChecked && !allowAction) {
      setIsChecked(false);
      return;
    }
    const checked = !isChecked;
    setIsChecked(checked);
    if (onChange) onChange(checked, name);
    //This is added to avoid row click handler, when clicking on checkbox
    window.isTableCellAction = true;
    setTimeout(() => (window.isTableCellAction = false));
  };

  return (
    <div className={`dupont-checkbox-container ${customClass || ""}`}>
      <input
        className={`dupont-checkbox ${indeterminateStyle}`}
        type="checkbox"
        id={checkboxId}
        name={name}
        required={required}
        checked={isChecked}
        onChange={clickHandler}
        disabled={disabled}
        onClick={onClick}
      />
      {labelText && (
        <label
          className={`dupont-checkbox__label ${customClass}`}
          htmlFor={name}
        >
          {labelText}
        </label>
      )}
    </div>
  );
}
